import { useCallback } from "react";

import { logException, trackEvent } from "utils";

export const useVimeoTracking = (eventName) => {
  const playerRef = useCallback(
    (node) => {
      if (node === null) {
        return;
      }
      const onPlay = () => {
        trackEvent(`${eventName} video played`);
      };

      const onPause = () => {
        trackEvent(`${eventName} video paused`);
      };

      try {
        const player = new Vimeo.Player(node);
        player.on("play", onPlay);
        player.on("pause", onPause);
      } catch (err) {
        // eat errors, we just won't track the video events
        logException(err);
      }
    },
    [eventName]
  );

  return playerRef;
};
